angular.module('app')
.controller('headerCtrl', function ($location, $scope, auth) {
	$scope.$location = $location;
	$scope.isLoggedIn = auth.isLoggedIn;
  $scope.currentUser = auth.currentUser;
  $scope.logOut = auth.logOut;

	auth.userCount(function(data){
    $scope.userCount = data;
  });
})
.directive('header', function () {
    return {
        restrict: 'A',
        templateUrl: 'views/header.html',
        link: function () {
        }
    };
});
